import { inject } from "@angular/core";
import { NotificationService } from "./notification.service";
import { MetaMaskService } from "./metamask-service";
import { JsonRpcSigner } from "ethers";
import { DhrQuarkusService } from "./dhr.service";

/**
 * Clase base de todos los servios
 */
export abstract class BaseService {
    notificationService: NotificationService = inject(NotificationService);
    
    
  

    protected format(object: any): string{   
        let retorno =  JSON.stringify(object, null, 4);
        //console.log(retorno);
        return retorno;
    }
    constructor() {
        
    }
    protected getJSON(object: any):string{
        return JSON.stringify(object, (
            (key, value) => {
            typeof value === 'bigint'
                    ? value.toString()
                    : value // return everything else unchanged
            }
        ), 2);
    }
   

}